import React from "react";
import Alert from "../components/alert.jsx";
import Cookies from "js-cookie";
const STORAGE_KEY = "PLATFORM_ALERTS";

const _getFromCookie = () => {
  const seenAlerts = Cookies.get(STORAGE_KEY);

  if (seenAlerts) {
    return JSON.parse(seenAlerts);
  }
  return {};
};

const _getUnseenAlert = (alerts) => {
  if (!alerts || !alerts.length || !Array.isArray(alerts)) {
    return null;
  }

  const seenAlerts = _getFromCookie();
  const usnseenAlerts = alerts.filter((alert) => {
    return !seenAlerts[alert.id];
  });

  if (usnseenAlerts.length) {
    return usnseenAlerts[0];
  }

  return null;
};

const _onAlertDismissed = (platformAlertId) => {
  const seenAlerts = _getFromCookie();

  if (!seenAlerts[platformAlertId]) {
    seenAlerts[platformAlertId] = true;

    Cookies.set(STORAGE_KEY, JSON.stringify(seenAlerts));
  }
};

const getPlatformAlertView = (alerts, onClose, fixedToTop) => {
  const alert = _getUnseenAlert(alerts);

  if (alert) {
    return (
      <Alert
        className="platform-alert"
        key="success"
        type="success"
        fixedToTop={fixedToTop || false}
        markdownHtml={true}
        onClose={() => {
          _onAlertDismissed(alert.id);
          onClose();
        }}
        message={alert.message}
      />
    );
  }
  return null;
};

export default getPlatformAlertView;



// WEBPACK FOOTER //
// ./client/helpers/platform-banners.jsx